import messages from './messages';
import { MessageConfigType } from '../../types';
import {
  ACCOUNT_SUB_MENU_LIST,
  ANALYTICS_SUB_MENU_LIST,
  ASSETS_SUB_MENU_LIST,
  CALL_AI_SUB_MENU_LIST,
  DSR_SUB_MENU_LIST,
  NAVIGATION_MENU_LIST,
  TRAINING_SUB_MENU_LIST,
  USERS_SUB_MENU_LIST,
} from './enum';

const navigationMessagesConfig: MessageConfigType = {
  [NAVIGATION_MENU_LIST.TRAINING]: {
    expandedName: messages.TRAINING,
    collapsedName: messages.TRAINING,
    subMenuName: {
      [TRAINING_SUB_MENU_LIST.TRAINING_OVERVIEW]: {
        expandedName: messages.TRAINING_OVERVIEW,
        collapsedName: messages.TRAINING_OVERVIEW,
      },
      [TRAINING_SUB_MENU_LIST.TRAINING_SERIES]: {
        expandedName: messages.TRAINING_SERIES,
        collapsedName: messages.TRAINING_SERIES,
      },
      [TRAINING_SUB_MENU_LIST.TRAINING_SERIES_OVERVIEW]: {
        expandedName: messages.TRAINING_SERIES_OVERVIEW,
        collapsedName: messages.TRAINING_SERIES_OVERVIEW,
      },
      [TRAINING_SUB_MENU_LIST.TRAINING_MODULES]: {
        expandedName: messages.TRAINING_MODULES,
        collapsedName: messages.TRAINING_MODULES,
      },
      [TRAINING_SUB_MENU_LIST.TRAINING_ILT]: {
        expandedName: messages.TRAINING_ILT,
        collapsedName: messages.TRAINING_ILT,
      },
      [TRAINING_SUB_MENU_LIST.TRAINING_CERTIFICATIONS]: {
        expandedName: messages.TRAINING_CERTIFICATIONS,
        collapsedName: messages.TRAINING_CERTIFICATIONS,
      },
      [TRAINING_SUB_MENU_LIST.TRAINING_MARKETPLACE]: {
        expandedName: messages.TRAINING_MARKETPLACE,
        collapsedName: messages.TRAINING_MARKETPLACE,
      },
      [TRAINING_SUB_MENU_LIST.TRAINING_TAGS]: {
        expandedName: messages.TRAINING_TAGS,
        collapsedName: messages.TRAINING_TAGS,
      },
      [TRAINING_SUB_MENU_LIST.TRAINING_AI_TUTORIALS]: {
        expandedName: messages.TRAINING_AI_TUTORIALS,
        collapsedName: messages.TRAINING_AI_TUTORIALS,
      },
    },
  },
  [NAVIGATION_MENU_LIST.ASSETS]: {
    expandedName: messages.ASSETS,
    collapsedName: messages.ASSETS,
    subMenuName: {
      [ASSETS_SUB_MENU_LIST.ASSETS_ASSETS]: {
        expandedName: messages.ASSETS_ASSETS,
        collapsedName: messages.ASSETS_ASSETS,
      },
      [ASSETS_SUB_MENU_LIST.ASSETS_ATTRIBUTES]: {
        expandedName: messages.ASSETS_ATTRIBUTES,
        collapsedName: messages.ASSETS_ATTRIBUTES,
      },
      [ASSETS_SUB_MENU_LIST.ASSETS_HUBS]: {
        expandedName: messages.ASSETS_HUBS,
        collapsedName: messages.ASSETS_HUBS,
      },
      [ASSETS_SUB_MENU_LIST.ASSETS_HUBS_OVERVIEW]: {
        expandedName: messages.ASSETS_HUBS_OVERVIEW,
        collapsedName: messages.ASSETS_HUBS_OVERVIEW,
      },
    },
  },
  [NAVIGATION_MENU_LIST.CALL_AI]: {
    expandedName: messages.CALL_AI,
    collapsedName: messages.CALL_AI,
    subMenuName: {
      [CALL_AI_SUB_MENU_LIST.CALL_AI_LIBRARIES]: {
        expandedName: messages.CALL_AI_LIBRARIES,
        collapsedName: messages.CALL_AI_LIBRARIES,
      },
      [CALL_AI_SUB_MENU_LIST.CALL_AI_TRAINING_CALLS]: {
        expandedName: messages.CALL_AI_TRAINING_CALLS,
        collapsedName: messages.CALL_AI_TRAINING_CALLS,
      },
    },
  },
  [NAVIGATION_MENU_LIST.DSR]: {
    expandedName: messages.DSR,
    collapsedName: messages.DSR,
    subMenuName: {
      [DSR_SUB_MENU_LIST.DSR_ROOMS]: {
        expandedName: messages.DSR_ROOMS,
        collapsedName: messages.DSR_ROOMS,
      },
      [DSR_SUB_MENU_LIST.DSR_TEMPLATES]: {
        expandedName: messages.DSR_TEMPLATES,
        collapsedName: messages.DSR_TEMPLATES,
      },
      [DSR_SUB_MENU_LIST.DSR_INSIGHTS]: {
        expandedName: messages.DSR_INSIGHTS,
        collapsedName: messages.DSR_INSIGHTS,
      },
      [DSR_SUB_MENU_LIST.DSR_DEALS]: {
        expandedName: messages.DSR_DEALS,
        collapsedName: messages.DSR_DEALS,
      },
      [DSR_SUB_MENU_LIST.DSR_SETTINGS]: {
        expandedName: messages.DSR_SETTINGS,
        collapsedName: messages.DSR_SETTINGS,
      },
    },
  },
  [NAVIGATION_MENU_LIST.CONTENT_CENTER]: {
    expandedName: messages.CONTENT_CENTER,
    collapsedName: messages.CONTENT_CENTER_COLLAPSED,
    subMenuName: {},
  },
  [NAVIGATION_MENU_LIST.ANALYTICS]: {
    expandedName: messages.ANALYTICS,
    collapsedName: messages.ANALYTICS,
    subMenuName: {
      [ANALYTICS_SUB_MENU_LIST.ANALYTICS_TRAINING]: {
        expandedName: messages.ANALYTICS_TRAINING,
        collapsedName: messages.ANALYTICS_TRAINING,
      },
      [ANALYTICS_SUB_MENU_LIST.ANALYTICS_ASSETS]: {
        expandedName: messages.ANALYTICS_ASSETS,
        collapsedName: messages.ANALYTICS_ASSETS,
      },
      [ANALYTICS_SUB_MENU_LIST.ANALYTICS_CALL_AI]: {
        expandedName: messages.ANALYTICS_CALL_AI,
        collapsedName: messages.ANALYTICS_CALL_AI,
      },
      [ANALYTICS_SUB_MENU_LIST.ANALYTICS_COACHING]: {
        expandedName: messages.ANALYTICS_COACHING,
        collapsedName: messages.ANALYTICS_COACHING,
      },
      [ANALYTICS_SUB_MENU_LIST.ANALYTICS_MY]: {
        expandedName: messages.ANALYTICS_MY,
        collapsedName: messages.ANALYTICS_MY,
      },
      [ANALYTICS_SUB_MENU_LIST.ANALYTICS_RI]: {
        expandedName: messages.ANALYTICS_RI,
        collapsedName: messages.ANALYTICS_RI,
      },
      [ANALYTICS_SUB_MENU_LIST.ANALYTICS_USERS]: {
        expandedName: messages.ANALYTICS_USERS,
        collapsedName: messages.ANALYTICS_USERS,
      },
      [ANALYTICS_SUB_MENU_LIST.ANALYTICS_ORG_READINESS]: {
        expandedName: messages.ANALYTICS_ORG_READINESS,
        collapsedName: messages.ANALYTICS_ORG_READINESS,
      },
    },
  },
  [NAVIGATION_MENU_LIST.USERS]: {
    expandedName: messages.USERS,
    collapsedName: messages.USERS,
    subMenuName: {
      [USERS_SUB_MENU_LIST.USERS_USERS]: {
        expandedName: messages.USERS_USERS,
        collapsedName: messages.USERS_USERS,
      },
      [USERS_SUB_MENU_LIST.USERS_GROUPS]: {
        expandedName: messages.USERS_GROUPS,
        collapsedName: messages.USERS_GROUPS,
      },
      [USERS_SUB_MENU_LIST.USERS_PROFILE]: {
        expandedName: messages.USERS_PROFILE,
        collapsedName: messages.USERS_PROFILE,
      },
      [USERS_SUB_MENU_LIST.USERS_ROLES]: {
        expandedName: messages.USERS_ROLES,
        collapsedName: messages.USERS_ROLES,
      },
    },
  },
  [NAVIGATION_MENU_LIST.ACCOUNT_SETTINGS]: {
    expandedName: messages.ACCOUNT_SETTINGS,
    collapsedName: messages.ACCOUNT_SETTINGS_COLLAPSED,
    subMenuName: {
      [ACCOUNT_SUB_MENU_LIST.ACCOUNT_SETTINGS_HOMEPAGES]: {
        expandedName: messages.ACCOUNT_SETTINGS_HOMEPAGES,
        collapsedName: messages.ACCOUNT_SETTINGS_HOMEPAGES,
      },
      [ACCOUNT_SUB_MENU_LIST.ACCOUNT_SETTINGS_AUTO_SUITE]: {
        expandedName: messages.ACCOUNT_SETTINGS_AUTO_SUITE,
        collapsedName: messages.ACCOUNT_SETTINGS_AUTO_SUITE,
      },
      [ACCOUNT_SUB_MENU_LIST.ACCOUNT_SETTINGS_EMAIL]: {
        expandedName: messages.ACCOUNT_SETTINGS_EMAIL,
        collapsedName: messages.ACCOUNT_SETTINGS_EMAIL,
      },
      [ACCOUNT_SUB_MENU_LIST.ACCOUNT_SETTINGS_INTEGRATIONS]: {
        expandedName: messages.ACCOUNT_SETTINGS_INTEGRATIONS,
        collapsedName: messages.ACCOUNT_SETTINGS_INTEGRATIONS,
      },
      [ACCOUNT_SUB_MENU_LIST.ACCOUNT_SETTINGS_CUSTOM_PROPERTIES]: {
        expandedName: messages.ACCOUNT_SETTINGS_CUSTOM_PROPERTIES,
        collapsedName: messages.ACCOUNT_SETTINGS_CUSTOM_PROPERTIES,
      },
      [ACCOUNT_SUB_MENU_LIST.ACCOUNT_SETTINGS_LOGS]: {
        expandedName: messages.ACCOUNT_SETTINGS_LOGS,
        collapsedName: messages.ACCOUNT_SETTINGS_LOGS,
      },
      [ACCOUNT_SUB_MENU_LIST.ACCOUNT_SETTINGS_WGLL_LIBRARY]: {
        expandedName: messages.ACCOUNT_SETTINGS_WGLL_LIBRARY,
        collapsedName: messages.ACCOUNT_SETTINGS_WGLL_LIBRARY,
      },
      [ACCOUNT_SUB_MENU_LIST.ACCOUNT_SETTINGS_SETTINGS]: {
        expandedName: messages.ACCOUNT_SETTINGS_SETTINGS,
        collapsedName: messages.ACCOUNT_SETTINGS_SETTINGS,
      },
    },
  },
};

export default navigationMessagesConfig;
